SWR.Social.prototype._loadYouTube = function _loadYouTube(){
  var self = this;
  var a = COMMON.Utils.parseUrl(self.url);
  console.log(a);
  var listId, videoId, startTime, shorts;

  if (a.params.hasOwnProperty('v')) {
    videoId = a.params.v;
  }
  // Playlist
  if (a.params.hasOwnProperty('list')) {
    listId = a.params.list;
  }
  if (a.params.hasOwnProperty('t')) {
    startTime = a.params.t;
  }
  if (a.params.hasOwnProperty('start')) {
    startTime = a.params.start;
  }

  //Shorts
  if (a.path.indexOf('/shorts/') > -1) {
    videoId = a.path.replace('/shorts/', '');
  }

  // Fallback
  if (!videoId && !listId) {
    videoId = self.url.match(/(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})?/i).pop();
  }

  var params = {};
  if (listId) {
    params['list'] = listId;
  }
  if (startTime) {
    params['start'] = startTime;
  }

  params['wmode'] = 'opaque';
  params['hl'] = 'de_DE';
  params['rel'] = 0;
  params['modestbranding'] = 1;
  params['showinfo'] = 1;
  params['iv_load_policy'] = 3;
  params['feature'] = 'oembed';
  params['vq'] = 'hd1080';
  params['origin'] = window.location.origin;

  console.log(params);
  console.log(encodeQueryData(params));
  console.log(videoId);
  var uri = 'https://www.youtube-nocookie.com/embed/' + videoId + '?' + encodeQueryData(params);
  //var uri = 'https://www.youtube.com/embed' + (videoId ? '/' + videoId : '') + '?' + encodeQueryData(params);

  try {
    var html = COMMON.Utils.template('<div class="embed-responsive embed-responsive-16by9">' +
      '<iframe class="embed-responsive-item" src="{url}" allowFullScreen="true" style="top: 0px; left: 0px; width: 100%; height: 100%; position: absolute; border: 0"></iframe>' +
      '</div>', {
      'url': uri
    });
    self._done(html);
  } catch (e) {
    self._failed(self.config.embedType, self.url);
  }

  function encodeQueryData(data) {
    var ret = [];
    for (var key in data)
      ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    return ret.join('&');
  }
};
